import React from "react";
import IconComponent from "../../aGlobalDesign/Icons/IconComponent";

const CardAd = ({ ad, reportingAd }) => {
    return (
        <div className='card-ad-container' key={ad.id}>
            <div className='card-ad'>
                <img className='thumb-card-ad' alt="image ad" src={JSON.parse(ad.thumbMobile).url} />
                <div className='infos-card-ad'>
                    <p className='name-card-ad'>{ad.name}</p>
                    <div className='view-click-card-ad'>
                        <div className='view-click-icon-card-ad'>
                            <IconComponent dimensions="24" nameIcon="eye" color="carbone" />
                            <p>{reportingAd && reportingAd.views}</p>
                        </div>
                        {
                            ad.actionButton ?
                                <div className='view-click-icon-card-ad'>
                                    <IconComponent dimensions="24" nameIcon="click" color="carbone" />
                                    <p>{reportingAd && reportingAd.clicks}</p>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardAd;
